// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPlusIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M10.611 10.611V3.39a1.389 1.389 0 1 1 2.778 0v7.222h7.222a1.389 1.389 0 1 1 0 2.778H13.39v7.222a1.389 1.389 0 1 1-2.778 0V13.39H3.39a1.389 1.389 0 1 1 0-2.778z"
    />
  </g>
);
export default SvgPlusIcon;
SvgPlusIcon.displayName = 'SvgPlusIcon';
